const nawozyTvTypes = [
  { label: 'Nawozy Nonstop', value: 1 },
  { label: 'Wiadomości Nonstop', value: 2 },
  { label: 'Shorts', value: 3 },
];

export default nawozyTvTypes;
